import { convertMinutesToHours } from '@nile/mangifera/src/Utils/helpers';
import { Timer } from '@styled-icons/remix-fill';
import {
  ALL_MODULES,
  AsyncCheckbox,
  AsyncRadio,
  AsyncSelect,
  CustomDateField,
  CustomTextField,
  AsyncRadioNew
} from '@nile/components';
import { isEmpty, cloneDeep } from 'lodash';
import React from 'react';
import { getCellValue } from '@nile/reports/src/modules/EfficiencyReport/util';

function CustomRadioCell(props) {
  const { cell } = props;
  const ticket = cell.row.original;
  const {
    field,
    editable,
    actions,
    module,
    getCustomFieldValue,
    meta
  } = cell.column;
  let fieldValue = getCustomFieldValue
    ? getCustomFieldValue(ticket, field)
    : ticket?.customFields?.[field.name] || '';
  if (fieldValue && field.uiDataType === 'select') {
    fieldValue = {
      name: fieldValue,
      value: fieldValue,
      label: fieldValue
    };
  } else if (fieldValue && field.uiDataType === 'multi_select') {
    fieldValue = fieldValue.map((el) => {
      return {
        name: el,
        value: el,
        label: el
      };
    });
  }

  const getIsFieldEditable = () => {
    if (field?.nestedTo) {
      const parentValue =
        getCellValue(
          ticket,
          field?.parent?.isCustom
            ? `customFields.${field?.nestedTo}`
            : field?.nestedTo
        ) || null;
      if (!parentValue) {
        return false;
      }
    }
    return editable;
  };

  const isFieldEditable = getIsFieldEditable();

  const updateSelection = (f, val) => {
    const allCustomFieldValues = !isEmpty(ticket.customFields)
      ? cloneDeep(ticket.customFields)
      : {};
    if (f?.nestedAttributes) {
      const nestedChild = [];
      const getNestedChilds = (fld) => {
        fld?.nestedAttributes?.map((el) => {
          const child = meta?.ticketAttributes?.find(
            (attr) => attr?.name === el
          );
          if (child) {
            nestedChild.push(child);
          }
          if (child?.nestedAttributes) {
            getNestedChilds(child);
          }
        });
      };
      getNestedChilds(f);
      if (!isEmpty(nestedChild)) {
        nestedChild?.map((el) => (allCustomFieldValues[el?.name] = null));
      }
    }

    if (val?.label) {
      allCustomFieldValues[f.name] = val.label;
    } else if (f.uiDataType === 'multi_select') {
      allCustomFieldValues[f.name] = val.map((el) => el.label);
    } else {
      allCustomFieldValues[f.name] = val;
    }
    if (actions.save)
      actions.save({ customFields: allCustomFieldValues }, ticket, props.data);
  };
  return (
    <div>
      {module === ALL_MODULES.ticket || !module ? (
        <AsyncRadioNew
          defaultValue={fieldValue}
          updateSelection={(v) => {
            updateSelection(field, v);
          }}
          value={fieldValue}
          ticket={ticket}
          data={ticket}
          field={field}
          editable={isFieldEditable}
          inlineEdit
          module={module || ALL_MODULES.ticket}
          isMulti={field.uiDataType === 'multi_select'}
        />
      ) : (
        <AsyncRadio
          defaultValue={fieldValue}
          updateSelection={(v) => {
            updateSelection(field, v);
          }}
          value={fieldValue}
          ticket={ticket}
          data={ticket}
          field={field}
          editable={isFieldEditable}
          inlineEdit
          module={module || ALL_MODULES.ticket}
          isMulti={field.uiDataType === 'multi_select'}
        />
      )}
    </div>
  );
}

export default CustomRadioCell;
